import React from 'react';
import PropTypes from 'prop-types';
import Rating from 'react-rating';

import { getColor } from 'core/utils/Styles';

// Import icons individually for better code splitting
import StarEmpty from 'core/icons/StarEmpty';
import StarFull from 'core/icons/StarFull';
import Close from 'core/icons/Close';

import {
	HelpText as HelpTxt,
	RatingInputWrapper,
	RatingInputRow,
	ErrorMsgText,
	CloseWrapper,
	UndoWrapper,
} from './formStyles';

const getHelpText = (value) => {
	switch (value) {
		case 1: return "This box isn't for me";
		case 2: return 'This box is just ok';
		case 3: return 'Good but could be better';
		case 4: return 'I like this box';
		case 5: return 'I love this box';
	}
	return;
};

const HelpText = ({ value }) => {
	const helpTxt = getHelpText(value);
	if (!helpTxt) return null;

	return <HelpTxt>{helpTxt}</HelpTxt>;
};

HelpText.propTypes = {
	value: PropTypes.number,
};

class RatingStarInput extends React.PureComponent {
	state = {
		helpValue: null,
		closed: false,
	};

	syntheticEvt = (value) => {
		const { name } = this.props;
		return {
			target: { name, value },
		};
	};

	changeHandler = value => {
		const { syntheticEvt } = this;
		const evt = syntheticEvt(value);
		this.props.onFocus(evt);
		this.props.onChange(evt);
	};

	hoverHandler = helpValue => {
		const { syntheticEvt } = this;
		const evt = syntheticEvt(helpValue);
		this.props.onFocus(evt);
		if (this.state.helpValue != helpValue) this.setState({ helpValue });
	};

	onClickClose = e => {
		this.changeHandler(null);
		this.setState({ closed: true });
	};

	onClickOpen = e => {
		this.setState({ closed: false });
	};

	renderClosed() {
		return (
			<RatingInputRow >
				<div>Not rated.</div>
				<UndoWrapper onClick={this.onClickOpen}>undo</UndoWrapper>
			</RatingInputRow>
		);
	}

	render() {
		const { name, value, errorMsg, showHelp } = this.props;
		const { helpValue, closed } = this.state;
		const { changeHandler, hoverHandler } = this;
		const iconProps = { fill: getColor('primaryBrand'), width: 30, height: 30 };
		if (errorMsg) {
			iconProps.fill = getColor('salmon');
		}

		if ( closed ) {
			return this.renderClosed();
		}

		return (
			<RatingInputRow>
				<RatingInputWrapper>
					<Rating
						className="ratingStarInput"
						initialRating={value || 0}
						emptySymbol={<StarEmpty {...iconProps} />}
						fullSymbol={<StarFull {...iconProps} />}
						onChange={changeHandler}
						onHover={hoverHandler}
					/>
					<HelpText value={helpValue} />
					{showHelp && !helpValue && value && <HelpText value={value} />}
					<ErrorMsgText show={!!errorMsg}>{errorMsg}</ErrorMsgText>
					<input
						type="hidden"
						name={name}
						defaultValue={value}
					/>
				</RatingInputWrapper>
				{!showHelp && (
					<CloseWrapper>
						<Close
							onClick={this.onClickClose}
							fill={getColor('dustyGray')}
							width={'16px'}
							height={'16px'} />
					</CloseWrapper>
				)}
			</RatingInputRow>
		);
	}
}

RatingStarInput.propTypes = {
	name: PropTypes.string.isRequired,
	showHelp: PropTypes.bool,
	value: PropTypes.number,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	errorMsg: PropTypes.string,
};

RatingStarInput.defaultProps = {
	onChange: () => null,
	onFocus: () => null,
	showHelp: true,
};

export default RatingStarInput;
